import React from "react";
import { theme } from "@tm/utility/global";
import { H2TagStyle } from "./TextStyles.style";
import { usePartnerContext } from "@tm/static/partnerContext";
type Colors = typeof theme;
type ColorKey = keyof Colors;
interface H2TagProps {
  color?: Colors[ColorKey];
  children?: React.ReactNode;
  margin?: string;
}

const H2Tag: React.FC<H2TagProps> = ({ children, margin, color }) => {
  const context = usePartnerContext();
  return (
    <H2TagStyle
      context={context ? context : undefined}
      txtcolor={color}
      margin={margin}
    >
      {children}
    </H2TagStyle>
  );
};

export default H2Tag;
